export const objectDetailsPageState = {
	name: 'wmObjectDetailsPage',
	url: '/object-details/:_type/:_id/:widgetId?',
	title: 'Details page',
	component: 'mxObjectDetailsPage',
	lazyLoad: lazyLoadModules,
};

export const printObjectDetailsState = {
	name: 'wmPrintRoute',
	url: '/print-details/:print/:_type/:_id/:_archived/:widgetId?',
	title: 'Details page',
	component: 'mxObjectDetailsPage',
	lazyLoad: lazyLoadModules,
};

async function lazyLoadModules(transition) {
	const $ocLazyLoad = transition.injector().get('$ocLazyLoad');

	const { ObjectDetailsPageModule } = await import(/* webpackChunkName: "shell" */ './object-details-page.module');
	await $ocLazyLoad.inject({
		rerun: true,
		reconfig: true,
		name: ObjectDetailsPageModule.name,
	});

	const { shellAppModule } = await import(/* webpackChunkName: "shell" */ '../Shell/shell');
	await $ocLazyLoad.inject(shellAppModule.name, {}, true);

	const agentAppInitializerService = transition.injector().get('mx.sb.shell-app.AgentInitializerService');
	await agentAppInitializerService.initAgentApp();
}
